import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=3c31b3d4&"
import script from "./DataFilter.vue?vue&type=script&lang=js&"
export * from "./DataFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports